import { Injectable } from "@angular/core";
import { AddUpdateMerchantViewModel } from "./add-update-merchant-view-model";
import { TerminalSignUpDownloadModel } from "./add-update-terminal-sign-up-view-model";
import { ContactDetailsViewModel } from "./contact-details-view-model";
import { IdTextPair } from "./id-text-pair";

@Injectable({
  providedIn: 'root'
})

export class merchantTerminalsLink {
  public merchant: AddUpdateMerchantViewModel;
  public contact: ContactDetailsViewModel;
  public terminals: TerminalSignUpDownloadModel[];
  public locationData: { countries: [], regions: [], areas: [] };
  public commonData: any;
  public capabCommsProd = { productProfile: '', terminalCapabilities: '', commsProfile: '' };
  public productProfile: any;
  public terminalCapabilities: any;
  public commsProfile: any;
  public notes: string;
  public isbulkOrder: boolean;
  public termTypes: IdTextPair[];
  public merchantTypeIndicator: string;
}
